<script setup lang="ts">
import RoutingChoiceEditPage from '../features/routing-choices/RoutingChoiceEditPage.vue';
</script>

<template>
  <RoutingChoiceEditPage />
</template>
